// Shared segmentation options — used by Onboarding and Community signals editor.
export const SEGMENTATION_STEPS = [
  { id: "age",       label: "Age band",         options: ["18–24", "25–34", "35–44", "45–54", "55+"] },
  { id: "timezone",  label: "Timezone",         options: ["UTC-8", "UTC-5", "UTC+0", "UTC+1", "UTC+3", "UTC+5:30", "UTC+8", "UTC+9"] },
  { id: "religion",  label: "Ethos / faith",    options: ["Christian", "Muslim", "Jewish", "Hindu", "Buddhist", "Spiritual · non-denominational", "Secular"] },
  { id: "ethnicity", label: "Ethnicity",        options: ["West African", "East African", "South Asian", "East Asian", "Southeast Asian", "European", "Latin American", "Middle Eastern", "Mixed", "Prefer not to say"] },
  { id: "gender",    label: "Gender",           options: ["Female", "Male", "Non-binary", "Prefer not to say"] },
  { id: "language",  label: "Primary language", options: ["English", "Portuguese", "Spanish", "French", "Arabic", "Hindi", "Japanese", "Mandarin"] },
];

export const DEFAULT_SEGMENTATION = {
  age: "25–34",
  timezone: "UTC+0",
  religion: "Spiritual · non-denominational",
  ethnicity: "Mixed",
  gender: "Prefer not to say",
  language: "English",
};
